module.exports = __webpack_public_path__ + "img/horizontal_3_7_8019.1bc6a522.png";